module.exports = __webpack_public_path__ + "img/news_post_6.76b6f66b.png";